<div class="modal-header">
    <h2 class="modal-title">
        Email
        {{
            mode === 'Invoice'
                ? 'Invoice'
                : mode === 'SalesOrder'
                  ? 'Sales Order'
                  : mode === 'Dealer'
                    ? 'Dealer List'
                    : mode === 'Warranty'
                      ? 'Warranty'
                      : mode === 'ACH'
                        ? 'ACH'
                        : mode === 'SalesOrderMsrps'
                          ? 'MSRPs'
                          : mode === 'AchLink'
                            ? 'ACH Link'
                            : mode == 'AchRequest'
                              ? 'ACH Request'
                              : 'Purchase Order'
        }}
    </h2>
</div>
<div class="modal-body row" (keyup.esc)="cancel()">
    <div [class]="emailConfirmation ? 'col-6' : 'col-12'">
        <dx-form *ngIf="email" [formData]="email" validationGroup="mainValidationGroup" [readOnly]="readOnly">
            <dxi-item itemType="group">
                <dxi-item itemType="group" [colCount]="2">
                    <dxi-item [label]="{ text: 'Addresses' }" *ngIf="email && !readOnly">
                        <div *dxTemplate>
                            <dx-select-box [(value)]="selectedAddress" [items]="emailAddresses" valueExpr="email" displayExpr="email" searchEnabled="true" searchMode="startswith">
                            </dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item *ngIf="!readOnly">
                        <button type="button" class="btn btn-sm btn-success mt-1 me-4" (click)="addAddress()">Add Address</button>
                    </dxi-item>
                </dxi-item>

                <dxi-item dataField="to" [label]="{ text: 'To' }">
                    <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="cc" [label]="{ text: 'Cc' }"> </dxi-item>
                <dxi-item dataField="bcc" [label]="{ text: 'Bcc' }"> </dxi-item>
                <dxi-item dataField="subject" [label]="{ text: 'Subject' }"> </dxi-item>
                @if ((mode === 'AchLink' || mode === 'AchRequest') && !readOnly) {
                    <dxi-item [label]="{ text: 'Attach Invoice(s)' }">
                        <div *dxTemplate>
                            <dx-check-box [(value)]="attachInvoices"></dx-check-box>
                        </div>
                    </dxi-item>
                }

                <dxi-item [label]="{ text: 'Body' }">
                    <div *dxTemplate>
                        <dx-text-area [(value)]="email.body" [height]="550" [readOnly]="readOnly"> </dx-text-area>
                    </div>
                </dxi-item>
            </dxi-item>
        </dx-form>
        <div class="mt-4" *ngIf="showAttachments">
            <h4>Attachments</h4>
            <div>
                <ul style="list-style-type: none; padding-inline-start: 0px" *ngIf="attachments">
                    <li *ngFor="let attachment of attachments">
                        <a *ngIf="!readOnly" title="remove" (click)="removeAttachment($event, attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>&nbsp;
                        <a title="view" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                    </li>
                </ul>
            </div>
            <div *ngIf="!readOnly">
                <dx-file-uploader
                    name="fileUpload"
                    selectButtonText="Select File(s)"
                    class="attachments"
                    accept="*"
                    uploadMode="instantly"
                    [showFileList]="false"
                    [multiple]="true"
                    [uploadUrl]="uploadUrl"
                    [uploadHeaders]="uploadHeader"
                    (onUploadStarted)="uploadStarted($event)"
                    (onUploadError)="uploadError($event)"
                    (onUploaded)="uploaded($event)"
                >
                </dx-file-uploader>
            </div>
        </div>
    </div>
    <div *ngIf="emailConfirmation" class="col-6">
        <div class="row justify-content-center">
            <div class="col-10">
                <h3>Confirmations</h3>
                <dx-form>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-check-box [(value)]="includeConfirmation" text="Include Confirmation"></dx-check-box>
                        </div>
                    </dxi-item>
                    <dxi-item [label]="{ text: 'Type' }">
                        <div *dxTemplate>
                            <dx-select-box [(value)]="selectedType" [items]="types" [valueExpr]="'id'" [displayExpr]="'name'" [disabled]="!includeConfirmation"></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item [label]="{ text: 'Message' }">
                        <div *dxTemplate>
                            <dx-select-box [(value)]="selectedMessage" [items]="messages" [displayExpr]="'name'" [disabled]="!includeConfirmation"></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item *ngIf="selectedMessage">
                        <div *dxTemplate>
                            <label class="dx-field-item-label-text mt-2">Selected Message</label>
                            <dx-text-area [(value)]="selectedMessage.message" height="550px" [readOnly]="true" [disabled]="!includeConfirmation" [cap]></dx-text-area>
                        </div>
                    </dxi-item>
                </dx-form>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary me-auto" (click)="openReport()" *ngIf="showReportButton">View Report</button>
    <button type="button" class="btn btn-success" [disabled]="processing" (click)="save()" *ngIf="!readOnly">Send</button>
    <button type="button" class="btn btn-secondary" (click)="cancel()" *ngIf="!readOnly">Cancel</button>
    <button type="button" class="btn btn-secondary" (click)="close()" *ngIf="readOnly">Close</button>
</div>
